'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _httpRequest = require('@souche-f2e/http-request');

var _httpRequest2 = _interopRequireDefault(_httpRequest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Promise = require('es6-promise').Promise;

var env = process.env.NODE_ENV;

var dataBaseUrl = function dataBaseUrl() {
    if (env === 'production') {
        return 'https://traffic-v1.souche.com';
    }
    if (env === 'prepub') {
        return 'https://traffic-v1.prepub.souche.com';
    }
    return 'http://datacenter-log-center.dasouche-inc.net';
};

var javaBaseUrl = function javaBaseUrl() {
    if (env === 'production') {
        return 'https://lease.souche.com';
    }
    if (env === 'prepub') {
        return 'http://lease.prepub.souche.com';
    }
    return 'http://leasesite5.sqaproxy.souche.com';
};

var leaseconsumerBaseUrl = function leaseconsumerBaseUrl() {
    if (env === 'production') {
        return 'https://leaseconsumer.souche.com/';
    }
    if (env === 'prepub') {
        return 'https://leaseconsumer.prepub.souche.com/';
    }
    return 'http://leaseconsumer-a.sqaproxy.dasouche.net/';
};

var _jsonp = function _jsonp(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _httpRequest2.default.jsonp(url, params).then(function (res) {
        if (res.success) {
            return res.data;
        } else {
            console.log(res.msg || '系统异常'); // eslint-disable-line
            Promise.reject(res.msg || '系统异常');
        }
    }).catch(function (err) {
        console.error(url + '\u8C03\u7528\u5931\u8D25!\u9519\u8BEF\u539F\u56E0:' + err); // eslint-disable-line
        return Promise.reject(err);
    });
};

var _ajax = function _ajax(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    params.url = url;
    return _httpRequest2.default.ajax(params).then(function (res) {
        if (res.success) {
            return Promise.resolve(res.data);
        } else {
            console.error(res); // eslint-disable-line
            return Promise.reject(res.msg || '系统异常');
        }
    }).catch(function (err) {
        console.error(url + '\u8C03\u7528\u5931\u8D25!\u9519\u8BEF\u539F\u56E0:' + err); // eslint-disable-line
        return Promise.reject(err);
    });
};

exports.default = {
    jsonp: function jsonp(params) {
        return _jsonp(dataBaseUrl() + params.url, params.data);
    },
    ajax: function ajax(params) {
        return _ajax(javaBaseUrl() + params.url, {
            data: params.opts || {},
            type: params.method
        });
    },
    leaseconsumer: function leaseconsumer(params) {
        return _ajax(leaseconsumerBaseUrl() + params.url, {
            data: params.opts || {},
            type: params.method
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-f2e/souche-spm/dist/api/ajax.js
// module id = ScQ/
// module chunks = 8